import { WorkPeriodTagSchema } from '../../../backend/src/services/resources/work-period-tags/work-period-tag.types'
import { WorkPeriodTagRepositoryCreationPayload } from '../../../backend/src/services/resources/work-period-tags/work-period-tags.repository.service.types'
import api, { ApiResponse } from '.'
import { Employer } from './organizations'

export interface WorkPeriodTag extends Omit<WorkPeriodTagSchema, 'employer'> {
  _id: string
  employer: Employer
}

export const fetch = async (params?: any): Promise<ApiResponse<WorkPeriodTag[]>> =>
  await api({
    endpoint: '/work-period-tags',
    method: 'get',
    params: {
      sort: '-createdAt',
      ...(params || {}),
    },
  })

export const get = async (id: string): Promise<ApiResponse<WorkPeriodTag>> =>
  await api({
    endpoint: `/work-period-tags/${id}`,
    method: 'get',
  })

export type WorkPeriodTagCreationPayload = Omit<
  WorkPeriodTagRepositoryCreationPayload,
  'employer'
> & {
  isInactive?: boolean
}

export const create = async (
  params: WorkPeriodTagCreationPayload,
): Promise<ApiResponse<WorkPeriodTag>> =>
  await api({
    endpoint: '/work-period-tags',
    method: 'post',
    params,
  })

export interface WorkPeriodTagUpdatePayload extends Partial<WorkPeriodTagCreationPayload> {
  id: string
  isInactive?: boolean
}

export const update = async (
  params: WorkPeriodTagUpdatePayload,
): Promise<ApiResponse<WorkPeriodTag>> => {
  const { id, ...payload } = params
  return await api({
    endpoint: `/work-period-tags/${id}`,
    method: 'put',
    params: payload,
  })
}
